import { useState } from "react";
import CarePlanViewDrawer from "../../../../components/CarePlanViewDrawer";
import CustomDataGridV2 from "../../../../components/CustomDataGridV2";
import Text from "../../../../components/Text";
import useCurrentUser from "../../../../hooks/local-storage/use-current-user";
import useDisclosure from "../../../../hooks/use-disclosure";
import { usePatientPortalCarePlanListHealthRecord } from "../../../../queries/care-plan/use-patient-careplan-list-health-record";
import { CarePlan } from "../../../../services";
import { formatDate } from "../../../../utils/date-time-utility";
import {
  applyDefaultColumnSettings,
  DEF_PAGINATION,
  DGT_Pagination,
  getXtenantId,
} from "../../../../utils/utils";

const PatientPortalCarePlan = () => {
  const [pagination, setPagination] = useState<DGT_Pagination>(DEF_PAGINATION);
  const [currentUser] = useCurrentUser();
  const carePlanViewDisc = useDisclosure();

  const { data: carePlanList } = usePatientPortalCarePlanListHealthRecord({
    patientUuid: currentUser?.uuid ?? "",
    pagination,
    xTENANTID: getXtenantId(),
  });

  const columns = applyDefaultColumnSettings<CarePlan>([
    {
      field: "name",
      headerName: "Name",
      flex: 1,
      renderCell: ({ row, value }: any) =>
        value ? (
          <Text
            sx={{ cursor: "pointer" }}
            color={"#104E84"}
            onClick={() => carePlanViewDisc.open(row)}
          >
            {value}
          </Text>
        ) : (
          "-"
        ),
    },
    {
      field: "createdBy",
      headerName: "Provider Name",
      flex: 1,
    },
    {
      field: "assignDate",
      headerName: "Visit Date",
      flex: 1,
      renderCell: ({ value }: any) => (value ? formatDate(value) : "-"),
    },
    // {
    //   field: "endDate",
    //   headerName: "End Date",
    //   flex: 1,
    //   renderCell: ({ value }: any) => (value ? formatDate(value) : "-"),
    // },
    // {
    //   field: "active",
    //   headerName: "Status",
    //   flex: 1,
    //   renderCell: ({ value }: any) => (value ? "Active" : "Inactive"),
    // },
  ]);

  return (
    <>
      <CarePlanViewDrawer disclosureHost={carePlanViewDisc} />

      <CustomDataGridV2
        getRowId={(row) => row?.uuid}
        rows={carePlanList?.content ?? []}
        rowCount={carePlanList?.page?.totalElements ?? 0}
        columns={columns}
        paginationModel={pagination}
        onPaginationModelChange={setPagination}
      />
    </>
  );
};

export default PatientPortalCarePlan;
